












import { Vue, Component, Prop } from 'vue-property-decorator';
import Star from '@/components/icons/Star.vue';

@Component({
  components: {
    Star
  }
})
export default class Stars extends Vue {
  @Prop({ default: 5 }) stars!: number;
  @Prop({ default: 0 }) rating!: number;

  onClick(rate: number) {
    this.$emit('changeRate', rate);
  }

  get ratingList() {
    return Array.from(Array(this.stars + 1).keys())
      .reverse()
      .slice(0, -1);
  }
}
